// ST3 / RL2 — ÚNICO origen de la política de roles en el cliente.
//
// Tanto el menú (UserMenu) como los guards de ruta (ProductionRoute) leen de
// AQUÍ, y el rol viene de `user.role` (GET /me) — el mismo campo que el server
// valida en `get_production_user`. Una sola fuente: si mañana cambia quién ve
// las superficies de producción, se cambia en un sitio y menú + rutas quedan
// coherentes (no hay dos listas que puedan divergir).
//
// Superficies de PRODUCCIÓN (admin + supervisor): Projects, VFX Keyframes,
// Orca Lab, VFX Autopilot, Ingest, Pipeline Scores. El rol `user` (editor) usa
// solo el editor omni (`/`) + librería + jobs; `asist_edit`, solo `/asist-edit`.
export const PRODUCTION_ROLES = ["admin", "supervisor"];

export function canAccessProduction(user) {
  return !!user && PRODUCTION_ROLES.includes(user.role);
}

// Superficie de OPERADOR (espejo del server get_operator_user): la ingesta
// de shots la dispara CUALQUIER miembro del proyecto, no solo produccion.
// Permite admin/supervisor/user y solo excluye asist_edit (que vive en
// /asist-edit). La membresia real por-proyecto la valida el backend en el
// POST; este guard solo decide si la pagina se puede ver. Sin esto, el
// editor (role user) que pulsa “Ingest” era redirigido a `/`
// (Background Replace) por ProductionRoute.
export function canOperate(user) {
  return !!user && user.role !== "asist_edit";
}

export function isAdmin(user) {
  return !!user && user.role === "admin";
}
